export default function BrandStory() {
  return (
    <section id="about" className="py-24 px-6 bg-secondary-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-4">
          <p className="text-xs tracking-[0.3em] text-primary-500 mb-2 uppercase"
            style={{ fontFamily: "var(--font-heading)" }}>
            About
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">
          <div className="lg:col-span-3">
            <h2 className="text-4xl md:text-6xl font-light text-foreground-950 leading-tight mb-8"
              style={{ fontFamily: "var(--font-heading)" }}>
              Cute Design<br />for Everyday
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed max-w-xl"
              style={{ fontFamily: "var(--font-body)" }}>
              ROFFは、かわいくて機能的なグッズブランドです。
              ふんわりパステルの色彩と、使いやすさを重視したディテール。
              バッグ、ポーチ、クリアファイル、マルチクリーナー——
              どれもが、あなたの毎日をもっと楽しく、もっと素敵にするために生まれました。
            </p>
          </div>
          <div className="lg:col-span-2 flex items-end">
            <p className="text-sm text-foreground-500 leading-relaxed"
              style={{ fontFamily: "var(--font-body)" }}>
              私たちは「かわいいの、ちゃんと」を追求します。<br />
              見た目も気持ちも、両方大事に。<br />
              毎日使える、毎日使いたくなる。<br />
              そんなグッズをひとつずつ、丁寧に。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}